const PauseIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14" height="14" viewBox="0 0 14 14"
		stroke="currentColor"
		fill="none"
		{...props}
	>
		<path d="M9 3V11" strokeWidth="2"/>
		<path d="M5 3V11" strokeWidth="2"/>
	</svg>
)

export default PauseIcon